import { Routes } from '@angular/router';
import { ProviderSelectionAllowedGuard } from './guards';
import { ProviderComponent } from './pages';

export const providerRoutes: Routes = [
    {
        path: ':clientCode/provider',
        component: ProviderComponent,
        // A student who came in through a provider's deep link applies to that provider, so the
        // search is not theirs to use — hiding the links is not enough on its own (LA-22939).
        canActivate: [ProviderSelectionAllowedGuard]
    }
];
